import { Box, Theme, Typography, alpha } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useMatch } from 'react-router-dom';

import { getUserCanManageCatalogItems } from 'entities/User/model/selectors/userPermissionsSeletors';
import { getAddCatalogItemMode } from 'features/AddCatalogItem/model/selectors/addCatalogItemSelectors';
import { getAddInventoryItemMode } from 'features/AddInventoryItem/model/selectors/addInventoryItemSelectors';
import openBoxSearch from 'shared/assets/svg/open-box-search.svg';
import { EmptyPlaceholder } from 'shared/ui/EmptyPlaceholder/EmptyPlaceholder';

interface PropertyCatalogEmptyProps {
    selectedCategoryIsEmpty: boolean;
}

const emptyTextStyle = {
    color: (theme: Theme) => alpha(theme.palette.common.black, 0.5),
    typography: 'openSans.body2Medium',
    maxWidth: '280px',
};

export const PropertyCatalogEmpty = ({
    selectedCategoryIsEmpty,
}: PropertyCatalogEmptyProps) => {
    const { t } = useTranslation();

    const currentPageAddItemsInOrder = useMatch('/orders/add-items' + '/*');

    const isEditingCatalog = useSelector(getAddCatalogItemMode);
    const isEditingInventory = useSelector(getAddInventoryItemMode);
    const canEditCatalog = useSelector(getUserCanManageCatalogItems);
    const showEmptyTextForAddItems =
        !!isEditingInventory ||
        !!isEditingCatalog ||
        !!currentPageAddItemsInOrder;

    return (
        <Box height="100%">
            <EmptyPlaceholder image={openBoxSearch}>
                {selectedCategoryIsEmpty ? (
                    <>
                        <Typography
                            {...emptyTextStyle}
                            textAlign="center"
                            mb="24px"
                        >
                            {t('There are no Items in this category.')}
                        </Typography>
                        {!showEmptyTextForAddItems && canEditCatalog && (
                            <Typography {...emptyTextStyle} textAlign="center">
                                {t(
                                    'Click the Add to Catalog button to add items to the category. ',
                                )}
                            </Typography>
                        )}
                    </>
                ) : (
                    <Typography {...emptyTextStyle} textAlign="center">
                        {t('Select a category to view items')}.
                    </Typography>
                )}
            </EmptyPlaceholder>
        </Box>
    );
};
